import myapi from '../../api/index.js'

export default {
  namespaced: true,
  state: {
    baberrage: {
      id: '',
      msg: '',
      type: ''
    }
  },
  mutations: {
    save: (state, data) => {
      state.baberrage.id = data.ID
      state.baberrage.msg = data.payload.text
      state.baberrage.type = data.baberrageType
    }
  },
  actions: {
    livelist: (context, data) => {
      return myapi.livelist(data)
    }
  }
}
